<template>
  <!-- 报告管理抽屉 -->
  <div class="cron-report-drawer">
    <!-- 标题栏 -->
    <!-- <div class="drawer-header">
      <h2>报告管理</h2>
      <button class="drawer-close" @click="$emit('close')">
        <i class="el-icon-close"></i>
      </button>
    </div> -->

    <!-- 描述 -->
    <div class="drawer-desc">
      基于 OpenCloud 搜索引擎和知识分析能力，根据用户输入的自定义分析框架，自主检索并定向分析，提供竞品与政策决策支持。
    </div>

    <!-- 即时分析输入框 -->
    <!-- <div class="instant-box">
      <div class="instant-label">
        <i class="fa fa-bolt"></i> 输入分析框架即时发起 (OpenCloud 自主检索)
      </div>
      <div class="instant-bar">
        <input
          v-model="instantPrompt"
          type="text"
          class="instant-input"
          placeholder="主题 + 自定义分析大纲（如：收集宁德时代欧洲进度，重点分析：1.建厂规模，2.对我司的影响）"
          @keydown.enter="handleInstantSubmit"
        />
        <button class="instant-btn" @click="handleInstantSubmit">
          <i class="fa fa-search"></i> 立即分析
        </button>
      </div>
    </div> -->

    <!-- 主 Tab 切换 -->
    <div class="tab-bar">
      <button
        class="tab-btn"
        :class="{ 'tab-active': activeTab === 'reports' }"
        @click="activeTab = 'reports'"
      >
        生成的报告
      </button>
      <button
        class="tab-btn"
        :class="{ 'tab-active': activeTab === 'tasks' }"
        @click="activeTab = 'tasks'"
      >
        任务配置
      </button>
      <!-- 异常详情快捷按钮：存在待处置异常时展示 -->
      <button
        v-if="firstPendingAnomalyReport"
        class="tab-anomaly-btn"
        title="查看异常详情"
        @click="openAnomalyDialog(firstPendingAnomalyReport)"
      >
        <i class="el-icon-warning-outline"></i> 异常详情
      </button>
    </div>

    <!-- Tab 内容区域 -->
    <div class="tab-content">
      <!-- ====== Tab 1: 生成的报告 ====== -->
      <template v-if="activeTab === 'reports'">
        <div class="reports-layout">
          <!-- 左侧分类筛选 -->
          <div class="filter-sidebar">
            <div class="filter-group-label">来源</div>
            <div
              class="filter-item"
              :class="{ 'filter-active': activeFilter === 'all' }"
              @click="activeFilter = 'all'"
            >
              <i class="fa fa-th-large"></i> 全部
            </div>
            <div
              class="filter-item"
              :class="{ 'filter-active': activeFilter === 'internal' }"
              @click="activeFilter = 'internal'"
            >
              <i class="fa fa-building-o"></i> 内部
            </div>
            <div
              class="filter-item"
              :class="{ 'filter-active': activeFilter === 'external' }"
              @click="activeFilter = 'external'"
            >
              <i class="fa fa-globe"></i> 外部
            </div>

            <div class="filter-divider"></div>
            <div class="filter-group-label">数字人</div>
            <div
              v-for="dh in agentList"
              :key="dh.id"
              class="filter-item"
              :class="{ 'filter-active': activeFilter === dh.id }"
              @click="activeFilter = dh.id"
            >
              <span class="filter-dot" :style="{ background: getFilterDotColor(dh.id) }"></span> {{ dh.name }}
            </div>
          </div>

          <!-- 右侧：搜索 + 报告列表 -->
          <div class="reports-main">
            <!-- 搜索框 -->
            <div class="search-box">
              <i class="fa fa-search search-icon"></i>
              <input
                v-model="searchKeyword"
                type="text"
                class="search-input"
                placeholder="搜索报告标题..."
              />
              <button
                v-if="searchKeyword"
                class="search-clear"
                @click="searchKeyword = ''"
              >
                <i class="fa fa-times-circle"></i>
              </button>
            </div>

            <!-- 报告列表（虚拟滚动） -->
            <div v-if="filteredReports.length === 0" class="empty-state">
              <i class="fa fa-folder-open-o"></i>
              {{ searchKeyword ? '未找到匹配"' + searchKeyword + '"的报告' : '暂无对应报告' }}
            </div>
            <div v-else class="report-list-wrap">
              <div class="report-list-header">
                <span>共 {{ filteredReports.length }} 篇报告</span>
              </div>
              <VirtualList
                ref="reportVirtualList"
                :items="filteredReports"
                :get-item-height="getReportItemHeight"
                :buffer="5"
                item-key="id"
              >
                <template #item="{ item }">
                  <div
                    class="report-item"
                    :class="{ 'report-expanded': expandedIds[item.id] }"
                  >
                    <!-- 摘要行 -->
                    <div
                      class="report-summary"
                      @click="toggleExpand(item.id)"
                    >
                      <div class="report-main">
                        <div class="report-title-row">
                          <span class="report-type-badge" :class="item.category === 'internal' ? 'type-internal' : 'type-external'">
                            {{ item.category === 'internal' ? '内部' : '外部' }}
                          </span>
                          <span class="report-cat-icon" :style="{ color: getReportCatColor(item.reportType) }">
                            <i :class="getReportCatIcon(item.reportType)"></i>
                          </span>
                          <span class="report-title">{{ item.title || '未命名' }}</span>
                          <!-- 异常状态角标 -->
                          <span
                            v-if="item.hasAnomaly"
                            class="anomaly-badge-inline"
                            :class="item.anomalyDispositionStatus ? 'anomaly-disposed' : 'anomaly-pending'"
                          >
                            {{ item.anomalyDispositionStatus ? '已处置' : '待处理' }}
                          </span>
                          <span v-if="item.agentName" class="report-agent-tag" :style="{ background: getAgentTagColor(item.agentId || item.agentName).bg, color: getAgentTagColor(item.agentId || item.agentName).text }">
                            {{ item.agentName }}
                          </span>
                          <span class="report-impact-dot" :style="{ color: getImpactColor(item.impactLevel) }">
                            {{ getImpactLabel(item.impactLevel) }}
                          </span>
                        </div>
                        <div class="report-desc">{{ item.summary || '暂无摘要' }}</div>
                      </div>
                      <div class="report-meta">
                        <span class="report-time">{{ item.createTime || item.updateTime || '—' }}</span>
                        <template v-if="item.hasAnomaly">
                          <button
                            class="anomaly-detail-inline-btn"
                            @click.stop="openAnomalyDialog(item)"
                          >异常详情</button>
                        </template>
                        <i class="fa fa-angle-down expand-icon" :class="{ rotated: expandedIds[item.id] }"></i>
                      </div>
                    </div>

                    <!-- 展开详情 -->
                    <div v-if="expandedIds[item.id]" class="report-detail">
                      <div class="report-meta-info">
                        <span><i class="fa fa-user-o"></i> 数字人: {{ item.agentName || '—' }}</span>
                        <span><i class="fa fa-tag"></i> 类型: {{ reportTypeLabel(item.reportType) }}</span>
                        <span><i class="fa fa-clock-o"></i> 创建: {{ item.createTime || '—' }}</span>
                      </div>
                      <div class="report-impact">
                        <div class="impact-label">报告摘要</div>
                        <div class="impact-text">{{ item.summary || '暂无' }}</div>
                      </div>
                      <div v-if="item.content" class="report-content-preview">
                        <div class="impact-label">报告内容预览</div>
                        <div class="impact-text">{{ item.content.substring(0, 500) }}{{ item.content.length > 500 ? '...' : '' }}</div>
                      </div>
                      <div class="report-actions">
                        <button class="action-btn action-primary" @click="viewDetail(item)">
                          <i class="fa fa-file-text-o"></i> 查看完整报告
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
              </VirtualList>
            </div>
          </div>
        </div>
      </template>

      <!-- ====== Tab 2: 任务配置 ====== -->
      <template v-if="activeTab === 'tasks'">
        <div class="tasks-tab">
          <!-- 新建任务表单 -->
          <template v-if="showCreateForm">
            <button class="back-btn" @click="cancelCreateForm">
              <i class="fa fa-arrow-left"></i> 返回任务列表
            </button>
            <div class="create-form">
              <div class="form-title">
                <i class="fa fa-plus-circle"></i> {{ isEditing ? '编辑定时任务' : '新建定时任务' }}
              </div>

              <!-- 任务名称 -->
              <div class="form-item">
                <label class="form-label">任务名称 <span class="required">*</span></label>
                <input
                  v-model="createForm.name"
                  type="text"
                  class="form-input"
                  placeholder="请输入任务名称"
                />
              </div>

              <!-- 数字人选择（仅数字人团队成员） -->
              <div class="form-item">
                <label class="form-label">执行数字人 <span class="required">*</span></label>
                <el-select
                  v-model="createForm.agentId"
                  placeholder="请选择数字人团队成员"
                  class="form-select-full"
                  filterable
                >
                  <el-option
                    v-for="agent in agentList"
                    :key="agent.id"
                    :label="agent.name"
                    :value="agent.id"
                  />
                </el-select>
              </div>

              <!-- 报告周期 -->
              <div class="form-item">
                <label class="form-label">报告周期 <span class="required">*</span></label>
                <div class="form-radio-group">
                  <label
                    v-for="p in periodOptions"
                    :key="p.value"
                    class="form-radio-item"
                  >
                    <input
                      type="radio"
                      v-model="cronPeriod"
                      :value="p.value"
                      class="form-radio"
                      @change="onCronPeriodChange"
                    />
                    <span class="form-radio-label">{{ p.label }}</span>
                  </label>
                </div>
              </div>

              <!-- Cron 表达式：根据周期切换为下拉框选择 -->
              <div class="form-item">
                <label class="form-label">执行时间 <span class="required">*</span></label>

                <!-- 日报：选择 时 + 分 -->
                <div v-if="cronPeriod === 'daily'" class="cron-selects">
                  <span class="cron-select-label">每天</span>
                  <el-select v-model="cronHour" class="cron-sel" placeholder="时">
                    <el-option v-for="h in 24" :key="h-1" :label="(h-1).toString().padStart(2,'0') + ' 时'" :value="h-1" />
                  </el-select>
                  <span class="cron-select-sep">:</span>
                  <el-select v-model="cronMinute" class="cron-sel" placeholder="分">
                    <el-option v-for="m in cronMinuteOptions" :key="m" :label="m.toString().padStart(2,'0') + ' 分'" :value="m" />
                  </el-select>
                </div>

                <!-- 周报：选择 周几 + 时 + 分 -->
                <div v-else-if="cronPeriod === 'weekly'" class="cron-selects">
                  <span class="cron-select-label">每周</span>
                  <el-select v-model="cronWeekDay" class="cron-sel" placeholder="周几">
                    <el-option
                      v-for="d in 7"
                      :key="d"
                      :label="weekDayLabel(d)"
                      :value="d"
                    />
                  </el-select>
                  <el-select v-model="cronHour" class="cron-sel" placeholder="时">
                    <el-option v-for="h in 24" :key="h-1" :label="(h-1).toString().padStart(2,'0') + ' 时'" :value="h-1" />
                  </el-select>
                  <span class="cron-select-sep">:</span>
                  <el-select v-model="cronMinute" class="cron-sel" placeholder="分">
                    <el-option v-for="m in cronMinuteOptions" :key="m" :label="m.toString().padStart(2,'0') + ' 分'" :value="m" />
                  </el-select>
                </div>

                <!-- 月报：选择 日 + 时 + 分 -->
                <div v-else-if="cronPeriod === 'monthly'" class="cron-selects">
                  <span class="cron-select-label">每月</span>
                  <el-select v-model="cronMonthDay" class="cron-sel cron-sel-day" placeholder="日">
                    <el-option v-for="d in 28" :key="d" :label="d + ' 日'" :value="d" />
                  </el-select>
                  <el-select v-model="cronHour" class="cron-sel" placeholder="时">
                    <el-option v-for="h in 24" :key="h-1" :label="(h-1).toString().padStart(2,'0') + ' 时'" :value="h-1" />
                  </el-select>
                  <span class="cron-select-sep">:</span>
                  <el-select v-model="cronMinute" class="cron-sel" placeholder="分">
                    <el-option v-for="m in cronMinuteOptions" :key="m" :label="m.toString().padStart(2,'0') + ' 分'" :value="m" />
                  </el-select>
                </div>

                <!-- 季报：选择 季度起始月 + 日 + 时 + 分 -->
                <div v-else-if="cronPeriod === 'quarterly'" class="cron-selects">
                  <span class="cron-select-label">每季度第</span>
                  <el-select v-model="cronQuarterStart" class="cron-sel cron-sel-quarter" placeholder="起始月">
                    <el-option v-for="q in quarterOptions" :key="q.value" :label="q.label" :value="q.value" />
                  </el-select>
                  <el-select v-model="cronMonthDay" class="cron-sel cron-sel-day" placeholder="日">
                    <el-option v-for="d in 28" :key="d" :label="d + ' 日'" :value="d" />
                  </el-select>
                  <el-select v-model="cronHour" class="cron-sel" placeholder="时">
                    <el-option v-for="h in 24" :key="h-1" :label="(h-1).toString().padStart(2,'0') + ' 时'" :value="h-1" />
                  </el-select>
                  <span class="cron-select-sep">:</span>
                  <el-select v-model="cronMinute" class="cron-sel" placeholder="分">
                    <el-option v-for="m in cronMinuteOptions" :key="m" :label="m.toString().padStart(2,'0') + ' 分'" :value="m" />
                  </el-select>
                </div>

                <!-- 年报：选择 月 + 日 + 时 + 分 -->
                <div v-else-if="cronPeriod === 'yearly'" class="cron-selects">
                  <span class="cron-select-label">每年</span>
                  <el-select v-model="cronMonth" class="cron-sel" placeholder="月">
                    <el-option v-for="mo in 12" :key="mo" :label="mo + ' 月'" :value="mo" />
                  </el-select>
                  <el-select v-model="cronMonthDay" class="cron-sel cron-sel-day" placeholder="日">
                    <el-option v-for="d in 28" :key="d" :label="d + ' 日'" :value="d" />
                  </el-select>
                  <el-select v-model="cronHour" class="cron-sel" placeholder="时">
                    <el-option v-for="h in 24" :key="h-1" :label="(h-1).toString().padStart(2,'0') + ' 时'" :value="h-1" />
                  </el-select>
                  <span class="cron-select-sep">:</span>
                  <el-select v-model="cronMinute" class="cron-sel" placeholder="分">
                    <el-option v-for="m in cronMinuteOptions" :key="m" :label="m.toString().padStart(2,'0') + ' 分'" :value="m" />
                  </el-select>
                </div>

                <!-- 最终生成的 Cron 表达式预览 -->
                <div class="cron-preview">
                  <span class="cron-preview-label">Cron 表达式：</span>
                  <code class="cron-preview-value">{{ computedCronExpression }}</code>
                </div>
              </div>

              <!-- 报告类型（report 类型时显示） -->
              <div class="form-item">
                <label class="form-label">报告类型 <span class="required">*</span></label>
                <div class="form-radio-group">
                  <label v-for="rt in reportTypeOptions" :key="rt.value" class="form-radio-item">
                    <input type="radio" v-model="createForm.reportType" :value="rt.value" class="form-radio" />
                    <span class="form-radio-label">{{ rt.label }}</span>
                  </label>
                </div>
              </div>

              <!-- 报告类别（report 类型时显示） -->
              <div class="form-item">
                <label class="form-label">报告类别 <span class="required">*</span></label>
                <div class="form-radio-group">
                  <label v-for="rc in categoryOptions" :key="rc.value" class="form-radio-item">
                    <input type="radio" v-model="createForm.category" :value="rc.value" class="form-radio" />
                    <span class="form-radio-label">{{ rc.label }}</span>
                  </label>
                </div>
              </div>

              <!-- 是否生成待办（report 类型时显示） -->
              <div class="form-item">
                <label class="form-check-label">
                  <input type="checkbox" v-model="createForm.decision" class="form-checkbox" />
                  <span class="form-label-inline">生成待办</span>
                </label>
              </div>

              <!-- 生成待办条件/指令（勾选生成待办时显示） -->
              <div v-if="createForm.taskType === 'report' && createForm.decision" class="form-item">
                <label class="form-label">生成待办的条件或指令</label>
                <textarea
                  v-model="createForm.decisionCondition"
                  class="form-textarea"
                  rows="3"
                  placeholder="输入异常识别规则，当报告数据触发以下条件时自动创建待办事项..."
                ></textarea>
              </div>

              <!-- 任务内容 -->
              <div class="form-item">
                <label class="form-label">任务内容</label>
                <textarea
                  v-model="createForm.triggerMessage"
                  class="form-textarea"
                  rows="4"
                  placeholder="输入任务提示词/内容..."
                ></textarea>
              </div>

              <!-- 推送渠道 -->
              <div class="form-item">
                <label class="form-label">推送渠道</label>
                <push-channel-select
                  v-model="createForm.pushChannels"
                  :agent-id="createForm.agentId"
                  source="cron-task-create"
                />
              </div>

              <!-- 是否启用 -->
              <div class="form-item">
                <label class="form-label">启用状态</label>
                <label class="toggle-switch form-toggle">
                  <input type="checkbox" v-model="createForm.enabled" />
                  <span class="toggle-track"></span>
                  <span class="toggle-thumb"></span>
                  <span class="toggle-label">{{ createForm.enabled ? '启用' : '停用' }}</span>
                </label>
              </div>

              <!-- 按钮 -->
              <div class="form-actions">
                <button class="form-btn form-btn-cancel" @click="cancelCreateForm">取消</button>
                <button class="form-btn form-btn-submit" @click="submitCreate" :disabled="submitting">
                  <i v-if="submitting" class="fa fa-spinner fa-pulse"></i>
                  {{ submitting ? '提交中...' : (isEditing ? '保存修改' : '创建任务') }}
                </button>
              </div>
            </div>
          </template>

          <!-- 任务列表 -->
          <template v-else>
            <div class="tasks-header">
              <span class="tasks-count">共 {{ taskList.length }} 个定时任务</span>
              <button class="new-task-btn" @click="openCreateForm">
                <i class="fa fa-plus"></i> 新建任务
              </button>
            </div>

            <div v-if="taskList.length === 0" class="empty-state">
              <i class="fa fa-folder-open-o"></i> 暂无定时任务
            </div>
            <div v-else class="task-list">
              <div v-for="item in taskList" :key="item.id" class="task-item">
                <div class="task-main">
                  <div class="task-title-row">
                    <span class="task-title">{{ item.name || '未命名任务' }}</span>
                    <span class="task-status-tag" :class="item.enabled ? 'tag-enabled' : 'tag-paused'">
                      <i :class="item.enabled ? 'fa fa-check-circle' : 'fa fa-pause-circle'"></i>
                      {{ item.enabled ? '启用' : '暂停' }}
                    </span>
                  </div>
                  <div class="task-info">
                    <span><i class="fa fa-user-o"></i> {{ item.agentName || '—' }}</span>
                    <span><i class="fa fa-clock-o"></i> {{ item.cronExpression || '—' }}</span>
                    <span><i class="fa fa-calendar"></i> 下次：{{ item.nextRunTime || '—' }}</span>
                    <span><i class="fa fa-history"></i> 最近：{{ item.lastRunTime || '—' }}</span>
                  </div>
                </div>
                <div class="task-actions">
                  <button class="task-btn" title="编辑" @click="editTask(item)">
                    <i class="fa fa-pencil"></i>
                  </button>
                  <button class="task-btn task-btn-run" title="立即执行" @click="runTask(item)">
                    <i class="fa fa-bolt"></i>
                  </button>
                  <button class="task-btn task-btn-del" title="删除" @click="deleteTask(item)">
                    <i class="fa fa-trash-o"></i>
                  </button>
                  <label class="toggle-switch">
                    <input type="checkbox" :checked="item.enabled" @change="toggleTask(item)" />
                    <span class="toggle-track"></span>
                    <span class="toggle-thumb"></span>
                  </label>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>

    <!-- 异常详情弹框 -->
    <AnomalyDetailDialog
      :visible.sync="anomalyDialogVisible"
      :report="anomalyDialogReport"
      @disposed="handleAnomalyDisposed"
    />
  </div>
</template>

<script>
import { AGENT_ID_MAP } from '@/store/modules/cosmoClaw'
import {
  getJobPageApi,
  getJobReportListApi,
  deleteJobApi,
  toggleJobApi,
  runJobApi,
  createJobApi,
  updateJobApi,
  getAgentListApi
} from '@/api/agentAuth'
import VirtualList from './VirtualList.vue'
import PushChannelSelect from '@/components/PushChannelSelect.vue'
import AnomalyDetailDialog from './AnomalyDetailDialog.vue'

/**
 * CronReportDrawer - 报告管理抽屉组件
 * 包含"生成的报告"和"任务配置"两个主 Tab
 * 任务配置 Tab 支持新建定时任务，对接 POST /claw/api/v1/cron-jobs 接口
 */
export default {
  name: 'CronReportDrawer',
  components: { VirtualList, PushChannelSelect, AnomalyDetailDialog },
  props: {
    /** 抽屉是否可见，用于触发数据刷新 */
    visible: { type: Boolean, default: false }
  },
  data() {
    return {
      /** 当前激活的 Tab */
      activeTab: 'reports',
      /** 左侧筛选类型 */
      activeFilter: 'all',
      /** 搜索关键词 */
      searchKeyword: '',
      /** 即时分析输入 */
      instantPrompt: '',
      /** 展开的报告项 ID 集合 */
      expandedIds: {},
      /** 报告列表（来自 cron-reports/page） */
      reportList: [],
      /** 任务配置列表（来自 cron-jobs/page） */
      taskDataList: [],
      /** 分页信息 */
      pagination: {
        total: 0,
        size: 10,
        current: 1,
        pages: 0
      },
      /** 是否显示新建任务表单 */
      showCreateForm: false,
      /** 提交中状态 */
      submitting: false,
      /** 是否为编辑模式 */
      isEditing: false,
      /** 编辑中的任务 ID */
      editingTaskId: null,
      /** 加载状态 */
      loading: false,
      /** 数字人列表（来自接口，仅保留数字人，过滤智能体） */
      agentList: [],
      /** 新建任务表单数据 */
      createForm: {
        name: '',
        agentId: '',
        taskType: 'report',
        enabled: true,
        source: 'decision',
        /** 报告类型：market(市场行情)/competitor(竞品动态)/policy(政策法规) */
        reportType: 'market',
        /** 报告类别：internal(经营报告)/external(咨询报告) */
        category: 'internal',
        /** 是否生成待办 */
        decision: false,
        /** 生成待办的条件或指令 */
        decisionCondition: '',
        /** 任务内容/提示词 */
        triggerMessage: '',
        /** 推送渠道 code 列表（与后端约定写入 reportConfig.pushChannels） */
        pushChannels: []
      },
      /** 报告周期：daily/weekly/monthly/quarterly/yearly */
      cronPeriod: 'daily',
      /** Cron 各部分选择值 */
      cronMinute: 0,
      cronHour: 9,
      cronMonthDay: 1,
      cronMonth: 1,
      cronQuarterStart: 1,
      /** 周报周几选择（1-7，1=周一 ... 7=周日） */
      cronWeekDay: 1,
      /** 任务类型选项 */
      taskTypeOptions: [
        { value: 'report', label: '报告' },
        { value: 'text', label: '文字消息' },
        { value: 'reminder', label: '提醒' }
      ],
      /** 报告类型选项 */
      reportTypeOptions: [
        { value: 'market', label: '市场行情' },
        { value: 'competitor', label: '竞品动态' },
        { value: 'policy', label: '政策法规' }
      ],
      /** 报告类别选项 */
      categoryOptions: [
        { value: 'internal', label: '经营报告' },
        { value: 'external', label: '咨询报告' }
      ],
      /** 报告周期选项 */
      periodOptions: [
        { value: 'daily', label: '日报' },
        { value: 'weekly', label: '周报' },
        { value: 'monthly', label: '月报' },
        { value: 'quarterly', label: '季报' },
        { value: 'yearly', label: '年报' }
      ],
      /** 季度起始月选项 */
      quarterOptions: [
        { value: 1, label: 'Q1(1月)' },
        { value: 4, label: 'Q2(4月)' },
        { value: 7, label: 'Q3(7月)' },
        { value: 10, label: 'Q4(10月)' }
      ],
      /** 分钟选项（步长5分钟） */
      cronMinuteOptions: Array.from({ length: 12 }, (_, i) => i * 5),
      /** 异常详情弹框可见性 */
      anomalyDialogVisible: false,
      /** 异常详情弹框当前报告 */
      anomalyDialogReport: null
    }
  },
  computed: {
    /** 根据周期和下拉选择自动拼装 5位 Cron 表达式（分 时 日 月 周） */
    computedCronExpression() {
      const m = this.cronMinute
      const h = this.cronHour
      const d = this.cronMonthDay
      switch (this.cronPeriod) {
        case 'daily':
          return `${m} ${h} * * ?`
        case 'weekly':
          // 周报：日=?，周=1-7（1=周一 ... 7=周日），与现有 Quartz 风格一致
          return `${m} ${h} ? * ${this.cronWeekDay}`
        case 'monthly':
          return `${m} ${h} ${d} * ?`
        case 'quarterly': {
          const m1 = this.cronQuarterStart
          return `${m} ${h} ${d} ${m1},${m1 + 3},${m1 + 6},${m1 + 9} ?`
        }
        case 'yearly':
          return `${m} ${h} ${d} ${this.cronMonth} ?`
        default:
          return `${m} ${h} * * ?`
      }
    },
    /** 任务列表（任务配置 Tab 专用） */
    taskList() {
      return this.taskDataList
    },
    /** 根据筛选条件过滤后的报告列表 */
    filteredReports() {
      let list = [...this.reportList]

      // 按内/外部分类
      if (this.activeFilter === 'internal') {
        list = list.filter(item => item.category === 'internal')
      } else if (this.activeFilter === 'external') {
        list = list.filter(item => item.category === 'external')
      }

      // 按数字人筛选（agentId 为数字ID时匹配）
      if (this.activeFilter !== 'all' && this.activeFilter !== 'internal' && this.activeFilter !== 'external') {
        list = list.filter(item => item.agentId === this.activeFilter)
      }

      if (this.searchKeyword) {
        const kw = this.searchKeyword.toLowerCase()
        list = list.filter(item =>
          (item.title || '').toLowerCase().includes(kw) ||
          (item.summary || '').toLowerCase().includes(kw)
        )
      }

      return list
    },
    /** 顶部"异常详情"按钮要打开的那条：hasAnomaly=true 且还没处置的第一条 */
    firstPendingAnomalyReport() {
      return this.filteredReports.find(
        (item) => item.hasAnomaly && !item.anomalyDispositionStatus
      ) || null
    }
  },
  watch: {
    /** 监听抽屉可见性，打开时重新拉取最新数据 */
    visible(val) {
      if (val) {
        this.fetchReports()
        this.fetchTasks()
      }
    },
    /**
     * 切换执行数字人：渠道的 available 是基于当前 agentId 判定，
     * 切换后清空旧勾选并重新拉取
     */
    'createForm.agentId': {
      handler(newVal, oldVal) {
        if (!newVal || newVal === oldVal) return
        this.createForm.pushChannels = []
      }
    }
  },
  methods: {
    /** 打开异常详情弹框 */
    openAnomalyDialog(report) {
      this.anomalyDialogReport = report
      this.anomalyDialogVisible = true
    },
    /** 异常处置完成回调 */
    handleAnomalyDisposed() {
      this.anomalyDialogVisible = false
      this.anomalyDialogReport = null
      this.fetchReports()
    },
    /** 获取报告类型对应的颜色 */
    getReportCatColor(reportType) {
      const map = { market: '#10b981', policy: '#ef4444', competitor: '#f59e0b' }
      return map[reportType] || '#94a3b8'
    },
    /** 获取报告类型对应的图标 */
    getReportCatIcon(reportType) {
      const map = { market: 'fa fa-line-chart', policy: 'fa fa-shield', competitor: 'fa fa-crosshairs' }
      return map[reportType] || 'fa fa-tag'
    },
    /** 左侧筛选数字人列表的圆点颜色 */
    getFilterDotColor(agentId) {
      const palette = ['#f59e0b', '#ec4899', '#6366f1', '#10b981', '#ef4444', '#8b5cf6']
      let hash = 0
      const id = String(agentId || '')
      for (let i = 0; i < id.length; i++) {
        hash = id.charCodeAt(i) + ((hash << 5) - hash)
      }
      return palette[Math.abs(hash) % palette.length]
    },
    /** 数字人标签颜色映射（不同数字人使用不同颜色） */
    getAgentTagColor(agentId) {
      const palette = [
        { bg: '#eef2ff', text: '#4a5ff3' }, // 蓝紫
        { bg: '#ecfdf5', text: '#10b981' }, // 翠绿
        { bg: '#fff7ed', text: '#f97316' }, // 橙色
        { bg: '#fdf2f8', text: '#ec4899' }, // 粉红
        { bg: '#f0fdf4', text: '#16a34a' }, // 绿色
        { bg: '#fef2f2', text: '#ef4444' }, // 红色
        { bg: '#f5f3ff', text: '#8b5cf6' }, // 紫色
        { bg: '#ecfeff', text: '#06b6d4' } // 青色
      ]
      let hash = 0
      const id = String(agentId || '')
      for (let i = 0; i < id.length; i++) {
        hash = id.charCodeAt(i) + ((hash << 5) - hash)
      }
      return palette[Math.abs(hash) % palette.length]
    },
    /** 报告类型中文 */
    reportTypeLabel(reportType) {
      const map = { market: '市场行情', policy: '政策法规', competitor: '竞品动态' }
      return map[reportType] || reportType || '其他'
    },
    /** 影响等级标签 */
    getImpactLabel(level) {
      const map = { 1: '重大影响', 2: '中度影响', 3: '常规监测' }
      return map[level] || '常规监测'
    },
    /** 影响等级颜色 */
    getImpactColor(level) {
      const map = { 1: '#e54b3d', 2: '#d98213', 3: '#94a3b8' }
      return map[level] || '#94a3b8'
    },
    /** 展开/折叠报告详情 */
    toggleExpand(id) {
      this.$set(this.expandedIds, id, !this.expandedIds[id])
      // 通知虚拟列表重新计算高度
      this.$nextTick(() => {
        if (this.$refs.reportVirtualList) {
          this.$refs.reportVirtualList.recalcOffsets()
        }
      })
    },
    /** 即时分析提交 */
    handleInstantSubmit() {
      const prompt = this.instantPrompt.trim()
      if (!prompt) {
        this.$message.warning('请输入分析要求与期望大纲')
        return
      }
      this.$message.info('即时分析功能开发中，敬请期待...')
      this.instantPrompt = ''
    },
    /** 计算每项高度：收起60px，展开根据content长度动态计算 */
    getReportItemHeight(item) {
      if (this.expandedIds[item.id]) {
        // 基础展开高度 + content长度折算
        const contentLen = (item.content || '').length
        const extra = Math.min(contentLen, 500) * 0.3 // 约0.3px/字
        return 220 + extra
      }
      return 60
    },
    /** 查看报告详情 */
    viewDetail(item) {
      this.$message.info('报告详情功能开发中，敬请期待...')
      console.log('查看报告详情:', item)
    },
    /** 编辑任务 - 打开表单并回显数据 */
    editTask(item) {
      this.isEditing = true
      this.editingTaskId = item.id

      // 回显基础字段
      this.createForm.name = item.name || ''
      this.createForm.agentId = item.agentId || ''
      this.createForm.taskType = item.taskType || 'report'
      this.createForm.enabled = !!item.enabled
      this.createForm.source = item.source || 'decision'
      this.createForm.triggerMessage = item.triggerMessage || ''
      this.createForm.pushChannels = []

      // 解析 reportConfig JSON 字符串回显报告配置
      if (item.reportConfig) {
        try {
          const rc = typeof item.reportConfig === 'string' ? JSON.parse(item.reportConfig) : item.reportConfig
          this.createForm.reportType = rc.reportType || 'market'
          this.createForm.category = rc.category || 'internal'
          this.createForm.decision = !!rc.decision
          this.createForm.decisionCondition = rc.decisionCondition || ''
          // 推送渠道（数组或逗号分隔字符串都兼容）
          const ch = rc.pushChannels
          if (Array.isArray(ch)) {
            this.createForm.pushChannels = ch.filter(Boolean)
          } else if (typeof ch === 'string' && ch.trim()) {
            this.createForm.pushChannels = ch.split(',').map((s) => s.trim()).filter(Boolean)
          }
        } catch (e) {
          // 解析失败使用默认值
          this.createForm.reportType = 'market'
          this.createForm.category = 'internal'
          this.createForm.decision = false
          this.createForm.decisionCondition = ''
        }
      }

      // 解析 cronExpression 回显周期和时间选择器
      this.parseCronExpression(item.cronExpression || '')

      this.showCreateForm = true
    },
    /** 将 Cron 表达式反向解析为表单选择器的值 */
    parseCronExpression(expr) {
      if (!expr) {
        this.cronPeriod = 'daily'
        this.cronMinute = 0
        this.cronHour = 9
        this.cronMonthDay = 1
        this.cronMonth = 1
        this.cronQuarterStart = 1
        this.cronWeekDay = 1
        return
      }
      const parts = expr.trim().split(/\s+/)
      if (parts.length < 5) {
        this.cronPeriod = 'daily'
        return
      }
      const [minute, hour, day, month, week] = parts

      this.cronMinute = parseInt(minute) || 0
      this.cronHour = parseInt(hour) || 9
      this.cronMonthDay = parseInt(day) || 1
      this.cronMonth = parseInt(month) || 1

      // 根据规则反向推断周期类型
      if (day === '*' && month === '*' && week === '?') {
        // 日报：m h * * ?
        this.cronPeriod = 'daily'
      } else if (day === '?' && month === '*' && /^[1-7]$/.test(week)) {
        // 周报：m h ? * N
        this.cronPeriod = 'weekly'
        this.cronWeekDay = parseInt(week) || 1
      } else if (month === '*' && week === '?') {
        // 月报：m h d * ?
        this.cronPeriod = 'monthly'
      } else if (month.includes(',') && week === '?') {
        // 季报：m h d m1,m4,m7,m10 ?
        this.cronPeriod = 'quarterly'
        // 取第一个月份作为季度起始月
        const firstMonth = parseInt(month.split(',')[0]) || 1
        this.cronQuarterStart = [1, 4, 7, 10].includes(firstMonth) ? firstMonth : 1
      } else if (week === '?') {
        // 年报：m h d M ?
        this.cronPeriod = 'yearly'
        this.cronMonth = parseInt(month) || 1
      } else {
        this.cronPeriod = 'daily'
      }
    },
    /**
     * 周几下拉展示文案：周一(1)..周日(7)
     * @param {Number} d 1-7
     */
    weekDayLabel(d) {
      const names = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
      const idx = Math.max(0, Math.min(6, (d || 1) - 1))
      return names[idx]
    },
    /** 立即执行任务 */
    async runTask(item) {
      try {
        const res = await runJobApi(item.id)
        if (res.code === 200 || res.code === '200' || res.code === 0) {
          this.$message.success('任务已触发执行')
          this.fetchTasks()
          this.fetchReports()
        }
      } catch (e) {
        console.error('执行任务失败:', e)
      }
    },
    /** 删除任务 */
    async deleteTask(item) {
      try {
        await this.$confirm('确认删除该任务？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const res = await deleteJobApi(item.id)
        if (res.code === 200 || res.code === '200' || res.code === 0) {
          this.$message.success('删除成功')
          this.fetchTasks()
        }
      } catch (e) {
        if (e !== 'cancel') {
          console.error('删除任务失败:', e)
        }
      }
    },
    /** 启用/停用任务 */
    async toggleTask(item) {
      try {
        const res = await toggleJobApi({ id: item.id, enabled: !item.enabled })
        if (res.code === 200 || res.code === '200' || res.code === 0) {
          this.$message.success(item.enabled ? '已停用' : '已启用')
          this.fetchTasks()
        }
      } catch (e) {
        console.error('切换任务状态失败:', e)
      }
    },
    /** 获取数字人列表（用数字 agentId 作为 value，过滤排除智能体） */
    async fetchAgentList() {
      try {
        const res = await getAgentListApi()
        if (res.code === 200 || res.code === '200' || res.code === 0) {
          const allList = res.data || []
          // 仅保留数字人：name 含"数字人"或 id/agentName 含 shu_zi_ren
          this.agentList = allList
            .filter(item => {
              const name = item.name || item.agentName || ''
              const sid = item.id || item.agentId || ''
              const sname = item.agentName || ''
              return name.includes('数字人') || sid.includes('shu_zi_ren') || sname.includes('shu_zi_ren')
            })
            .map(item => ({
              // 取数字 agentId 作为 value（API 可能放在 agentId 或 id 字段）
              id: item.agentId || item.id,
              name: item.displayName || item.name || item.agentName || item.id
            }))
          if (this.agentList.length === 0) {
            this.agentList = this.getDefaultAgentList()
          }
        }
      } catch (e) {
        console.error('获取数字人列表失败:', e)
        this.agentList = this.getDefaultAgentList()
      }
    },
    /** 默认数字人列表（降级用，使用数字 agentId） */
    getDefaultAgentList() {
      return [
        { id: AGENT_ID_MAP.ceo_shu_zi_ren, name: 'CEO数字人' },
        { id: AGENT_ID_MAP.cai_wu_shu_zi_ren, name: '财务数字人' },
        { id: AGENT_ID_MAP.gong_ying_lian_shu_zi_ren, name: '供应链数字人' }
      ]
    },
    /** 打开新建任务表单 */
    openCreateForm() {
      this.resetCreateForm()
      this.showCreateForm = true
    },
    /** 取消新建/编辑任务 */
    cancelCreateForm() {
      this.showCreateForm = false
      this.isEditing = false
      this.editingTaskId = null
      this.resetCreateForm()
    },
    /** 重置新建任务表单 */
    /** 报告周期切换时重置时间默认值 */
    onCronPeriodChange() {
      this.cronMinute = 0
      this.cronHour = 9
      this.cronMonthDay = 1
      this.cronMonth = 1
      this.cronQuarterStart = 1
      this.cronWeekDay = 1
    },
    resetCreateForm() {
      this.createForm = {
        name: '',
        agentId: this.agentList.length > 0 ? this.agentList[0].id : '',
        taskType: 'report',
        enabled: true,
        source: 'decision',
        reportType: 'market',
        category: 'internal',
        decision: false,
        decisionCondition: '',
        triggerMessage: '',
        pushChannels: []
      }
      this.cronPeriod = 'daily'
      this.cronMinute = 0
      this.cronHour = 9
      this.cronMonthDay = 1
      this.cronMonth = 1
      this.cronQuarterStart = 1
      this.cronWeekDay = 1
    },
    /** 提交创建/编辑任务 */
    async submitCreate() {
      // 表单校验
      if (!this.createForm.name.trim()) {
        this.$message.warning('请输入任务名称')
        return
      }
      if (!this.createForm.agentId) {
        this.$message.warning('请选择执行数字人')
        return
      }
      if (!this.computedCronExpression) {
        this.$message.warning('请选择执行时间')
        return
      }

      this.submitting = true
      try {
        /** 构造请求体 */
        const payload = {
          name: this.createForm.name.trim(),
          agentId: this.createForm.agentId,
          taskType: 'report',
          cronExpression: this.computedCronExpression.trim(),
          enabled: this.createForm.enabled,
          source: this.createForm.source,
          triggerMessage: this.createForm.triggerMessage || ''
        }

        // 附加 reportConfig 对象
        const rc = {
          reportType: this.createForm.reportType,
          category: this.createForm.category,
          decision: this.createForm.decision
        }
        if (this.createForm.decision && this.createForm.decisionCondition.trim()) {
          rc.decisionCondition = this.createForm.decisionCondition.trim()
        }
        // 推送渠道：去重 + 去空，约定嵌入 reportConfig.pushChannels
        const channels = Array.from(
          new Set((this.createForm.pushChannels || []).filter(Boolean))
        )
        if (channels.length) {
          rc.pushChannels = channels
        }
        payload.reportConfig = JSON.stringify(rc)

        // 编辑模式调用更新接口，创建模式调用创建接口
        if (this.isEditing) {
          payload.id = this.editingTaskId
          const res = await updateJobApi(payload)
          if (res.code === 200 || res.code === '200' || res.code === 0) {
            this.$message.success('任务修改成功')
            this.showCreateForm = false
            this.isEditing = false
            this.editingTaskId = null
            this.resetCreateForm()
            this.fetchTasks()
            this.fetchReports()
          }
        } else {
          const res = await createJobApi(payload)
          if (res.code === 200 || res.code === '200' || res.code === 0) {
            this.$message.success('任务创建成功')
            this.showCreateForm = false
            this.resetCreateForm()
            this.fetchTasks()
            this.fetchReports()
          }
        }
      } catch (e) {
        console.error(this.isEditing ? '修改任务失败:' : '创建任务失败:', e)
      } finally {
        this.submitting = false
      }
    },
    /** 获取报告列表（全查接口 + 虚拟滚动优化） */
    async fetchReports() {
      this.loading = true
      try {
        const res = await getJobReportListApi({ size: 9999 })
        if (res.code === 200 || res.code === '200' || res.code === 0) {
          const data = res.data || {}
          this.reportList = data.records || data || []
        }
      } catch (e) {
        console.error('获取报告列表失败:', e)
      } finally {
        this.loading = false
      }
    },
    /** 获取任务列表（来自 cron-jobs/page） */
    async fetchTasks() {
      try {
        const params = {
          page: this.pagination.current,
          size: this.pagination.size
        }
        const res = await getJobPageApi(params)
        if (res.code === 200 || res.code === '200' || res.code === 0) {
          const data = res.data || {}
          this.taskDataList = data.records || []
        }
      } catch (e) {
        console.error('获取任务列表失败:', e)
      }
    }
  },
  /** 组件挂载时获取数据 */
  mounted() {
    this.fetchReports()
    this.fetchTasks()
    this.fetchAgentList()
  }
}
</script>

<style lang="scss" scoped>
/* ── 抽屉整体 ── */
.cron-report-drawer {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
}

.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;

  h2 {
    font-size: 17px;
    font-weight: 600;
    color: #1a1a2e;
    margin: 0;
  }

  .drawer-close {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
    color: #999;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #f5f5f5;
      color: #333;
    }
  }
}

.drawer-desc {
  padding: 12px 20px 8px;
  font-size: 13px;
  color: #888;
  line-height: 1.6;
  flex-shrink: 0;
}

/* ── 即时分析输入框 ── */
.instant-box {
  margin: 8px 20px;
  padding: 16px;
  background: rgba(74, 95, 243, 0.03);
  border: 1px dashed rgba(74, 95, 243, 0.22);
  border-radius: 16px;
  flex-shrink: 0;

  .instant-label {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 6px;

    i { color: #4a5ff3; }
  }

  .instant-bar {
    display: flex;
    gap: 8px;

    .instant-input {
      flex: 1;
      min-width: 0;
      height: 38px;
      border: 1px solid #cbd5e1;
      border-radius: 10px;
      padding: 0 14px;
      font-size: 13px;
      outline: none;
      background: #fff;
      transition: border-color 0.2s;

      &:focus { border-color: #4a5ff3; }
      &::placeholder { color: #cbd5e1; }
    }

    .instant-btn {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 0 16px;
      height: 38px;
      background: #4a5ff3;
      color: #fff;
      border-radius: 10px;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      transition: background 0.2s;
      border: none;
      white-space: nowrap;
      flex-shrink: 0;

      &:hover { background: #3d52d5; }
    }
  }
}

/* ── Tab 切换栏 ── */
.tab-bar {
  display: flex;
  gap: 8px;
  border-bottom: 1px solid #e2e8f0;
  padding: 12px 20px 8px;
  flex-shrink: 0;

  .tab-btn {
    font-size: 13px;
    font-weight: 500;
    color: #64748b;
    background: transparent;
    border: none;
    padding: 6px 12px;
    cursor: pointer;
    border-radius: 8px;
    transition: all 0.2s;

    &:hover { background: #f1f5f9; color: #1e293b; }

    &.tab-active {
      background: #eef2ff;
      color: #4a5ff3;
      font-weight: 600;
    }
  }
}

/* ── Tab 内容区域 ── */
.tab-content {
  flex: 1;
  overflow-y: auto;
  padding: 8px 20px 20px;
}

/* ── 报告布局 ── */
.reports-layout {
  display: flex;
  gap: 16px;
  height: 100%;
}

/* ── 左侧筛选侧边栏 ── */
.filter-sidebar {
  width: 105px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;

  .filter-group-label {
    font-size: 10px;
    font-weight: 600;
    color: #94a3b8;
    text-transform: uppercase;
    margin-bottom: 2px;
    padding: 0 8px;
  }

  .filter-item {
    padding: 6px 8px;
    border-radius: 8px;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.15s;
    color: #64748b;
    display: flex;
    align-items: center;
    gap: 6px;

    i { font-size: 10px; width: 14px; text-align: center; }

    &:hover { background: #f8fafc; color: #1e293b; }

    &.filter-active {
      background: #eef2ff;
      color: #4a5ff3;
      font-weight: 600;
    }
  }

  .filter-divider {
    height: 1px;
    background: #e2e8f0;
    margin: 4px 0;
  }

  .filter-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex-shrink: 0;
  }
}

/* ── 右侧主区域 ── */
.reports-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.search-box {
  position: relative;
  margin-bottom: 12px;
  flex-shrink: 0;

  .search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #cbd5e1;
    font-size: 12px;
    pointer-events: none;
    z-index: 1;
  }

  .search-input {
    width: 100%;
    height: 36px;
    padding: 0 32px 0 32px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 12px;
    color: #334155;
    background: #fff;
    outline: none;
    transition: border-color 0.2s;
    box-sizing: border-box;

    &:focus { border-color: #4a5ff3; }
    &::placeholder { color: #cbd5e1; }
  }

  .search-clear {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #cbd5e1;
    cursor: pointer;
    padding: 2px;

    &:hover { color: #64748b; }
    i { font-size: 12px; }
  }
}

.empty-state {
  text-align: center;
  padding: 24px;
  color: #94a3b8;
  font-size: 12px;

  i { margin-right: 4px; }
}

.report-list-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.report-list-header {
  font-size: 11px;
  color: #94a3b8;
  padding: 4px 0 8px;
  flex-shrink: 0;
}

.report-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

/* ── 报告列表项 ── */
.report-item {
  border: 1px solid transparent;
  border-bottom-color: #f1f5f9;
  border-radius: 6px;
  transition: all 0.15s;
  overflow: hidden;

  &:hover { background: #f8fafc; }

  &.report-expanded {
    border-color: #e2e8f0;
    background: #fafafa;
  }
}

.report-summary {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 10px 12px;
  cursor: pointer;
  user-select: none;
  gap: 12px;
}

.report-main {
  flex: 1;
  min-width: 0;
}

.report-title-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.report-type-badge {
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 4px;
  font-weight: 600;
  flex-shrink: 0;

  &.type-internal { background: #eef2ff; color: #4a5ff3; }
  &.type-external { background: #f0fdf4; color: #16a34a; }
}

.report-title {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}

.report-cat-icon {
  font-size: 11px;
  flex-shrink: 0;
}

.report-impact-dot {
  font-size: 10px;
  font-weight: 600;
  flex-shrink: 0;
  white-space: nowrap;
}

.report-agent-tag {
  font-size: 10px;
  font-weight: 500;
  padding: 1px 8px;
  border-radius: 999px;
  flex-shrink: 0;
  white-space: nowrap;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.report-content-preview {
  margin-top: 10px;
}

.report-desc {
  font-size: 11px;
  color: #64748b;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.report-time {
  font-size: 11px;
  color: #94a3b8;
  white-space: nowrap;
}

// ── 异常详情顶部快捷按钮 ──
.tab-anomaly-btn {
  margin-left: auto;
  padding: 6px 12px;
  background: #fef2f2;
  color: #ef4444;
  border: 1px solid #fecaca;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: #fee2e2;
    border-color: #ef4444;
  }

  i { font-size: 14px; }
}

// ── 行内异常角标 ──
.anomaly-badge-inline {
  font-size: 10px;
  padding: 1px 8px;
  border-radius: 10px;
  margin-left: 8px;
  flex-shrink: 0;

  &.anomaly-pending {
    background: #fef2f2;
    color: #ef4444;
    border: 1px solid #fecaca;
    font-weight: 600;
  }

  &.anomaly-disposed {
    background: #f0fdf4;
    color: #16a34a;
    border: 1px solid #bbf7d0;
  }
}

// ── 行内异常详情按钮 ──
.anomaly-detail-inline-btn {
  font-size: 11px;
  color: #ef4444;
  background: transparent;
  border: 1px solid #fecaca;
  border-radius: 4px;
  padding: 2px 8px;
  margin-right: 6px;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: #fef2f2;
  }
}

.expand-icon {
  font-size: 14px;
  color: #94a3b8;
  transition: transform 0.2s;

  &.rotated { transform: rotate(180deg); }
}

/* ── 展开详情 ── */
.report-detail {
  padding: 0 12px 12px;
  border-top: 1px solid #f1f5f9;
  background: #fafafa;
  animation: slideDown 0.2s ease;
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}

.report-meta-info {
  font-size: 11px;
  color: #94a3b8;
  padding: 10px 0 8px;
  border-bottom: 1px dashed #e2e8f0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;

  span { display: flex; align-items: center; gap: 4px; }
}

.report-impact {
  margin-top: 10px;

  .impact-label {
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    margin-bottom: 6px;
  }

  .impact-text {
    font-size: 12px;
    color: #334155;
    line-height: 1.7;
  }
}

.report-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  border: none;

  &.action-primary {
    background: #4a5ff3;
    color: #fff;

    &:hover { background: #3d52d5; }
  }
}

/* ── 任务配置 Tab ── */
.tasks-tab {
  display: flex;
  flex-direction: column;
}

.tasks-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  .tasks-count {
    font-size: 12px;
    color: #94a3b8;
  }

  .new-task-btn {
    font-size: 12px;
    font-weight: 500;
    background: #eef2ff;
    color: #4a5ff3;
    border: none;
    padding: 6px 12px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover { background: #dde6ff; }
  }
}

.task-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.task-item {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.2s;
  background: #fff;

  &:hover {
    border-color: #cbd5e1;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  }
}

.task-main {
  flex: 1;
  min-width: 0;
}

.task-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;

  .task-title {
    font-size: 13px;
    font-weight: 500;
    color: #1e293b;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .task-status-tag {
    font-size: 10px;
    font-weight: 500;
    padding: 1px 6px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    gap: 3px;
    flex-shrink: 0;

    &.tag-enabled { background: #ecfdf5; color: #10b981; }
    &.tag-paused { background: #f1f5f9; color: #94a3b8; }
  }
}

.task-info {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 11px;
  color: #94a3b8;

  span { display: flex; align-items: center; gap: 4px; }
}

.task-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.task-btn {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  font-size: 12px;

  &:hover { background: #f1f5f9; color: #1e293b; }
  &.task-btn-run:hover { background: #eef2ff; color: #4a5ff3; }
  &.task-btn-del:hover { background: #fef2f2; color: #ef4444; }
}

/* ── 启用/停用开关 ── */
.toggle-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  margin-left: 4px;

  input {
    display: none;

    &:checked + .toggle-track { background: #10b981; }
    &:checked ~ .toggle-thumb { transform: translateX(14px); }
  }

  .toggle-track {
    width: 32px;
    height: 18px;
    background: #cbd5e1;
    border-radius: 999px;
    transition: background 0.2s;
  }

  .toggle-thumb {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 14px;
    height: 14px;
    background: #fff;
    border-radius: 50%;
    transition: transform 0.2s;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }
}

/* ── 返回按钮 ── */
.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #4a5ff3;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-bottom: 16px;

  &:hover { opacity: 0.8; }
}

/* ── 新建任务表单 ── */
.create-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-title {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  display: flex;
  align-items: center;
  gap: 6px;

  i { color: #4a5ff3; }
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-label {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;

  .required { color: #ef4444; margin-left: 2px; }
}

.form-input {
  width: 100%;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 12px;
  color: #334155;
  background: #fff;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;

  &:focus { border-color: #4a5ff3; }
  &::placeholder { color: #cbd5e1; }
}

.form-select-full {
  width: 100%;
}

/* ── Cron 下拉选择区域 ── */
.cron-selects {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.cron-select-label {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
}

.cron-sel {
  width: 110px;
}

.cron-sel-day {
  width: 100px;
}

.cron-sel-quarter {
  width: 130px;
}

.cron-select-sep {
  font-size: 13px;
  color: #94a3b8;
  font-weight: 600;
}

/* Cron 表达式预览 */
.cron-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 8px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
}

.cron-preview-label {
  font-size: 11px;
  color: #94a3b8;
  flex-shrink: 0;
}

.cron-preview-value {
  font-size: 12px;
  font-weight: 600;
  color: #4a5ff3;
  font-family: 'Courier New', Courier, monospace;
}

.form-radio-group {
  display: flex;
  gap: 16px;
}

.form-radio-item {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;

  .form-radio {
    accent-color: #4a5ff3;
    width: 14px;
    height: 14px;
    margin: 0;
  }

  .form-radio-label { font-size: 12px; color: #334155; }
}

.form-textarea {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 12px;
  color: #334155;
  background: #fff;
  outline: none;
  resize: vertical;
  font-family: inherit;
  box-sizing: border-box;
  transition: border-color 0.2s;

  &:focus { border-color: #4a5ff3; }
  &::placeholder { color: #cbd5e1; }
}

.form-desc {
  margin: 0;
  font-size: 11px;
  color: #94a3b8;
  line-height: 1.5;
}

/* ── 待办勾选 ── */
.form-check-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}

.form-checkbox {
  accent-color: #4a5ff3;
  width: 15px;
  height: 15px;
  margin: 0;
}

.form-label-inline {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}

.form-toggle {
  margin-left: 0;

  .toggle-label {
    font-size: 12px;
    color: #64748b;
    margin-left: 8px;
  }
}

.form-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding-top: 4px;
}

.form-btn {
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;

  &.form-btn-cancel {
    background: #f1f5f9;
    color: #64748b;

    &:hover { background: #e2e8f0; }
  }

  &.form-btn-submit {
    background: #4a5ff3;
    color: #fff;

    &:hover { background: #3d52d5; }
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}
</style>
